import { useEffect } from 'react';
import SEOArticleHero from './components/SEOArticleHero';
import SEOArticleSpecialization from './components/SEOArticleSpecialization';
import SEOArticleWhatIs from './components/SEOArticleWhatIs';
import SEOArticleStrategy from './components/SEOArticleStrategy';
import SEOArticleProcess from './components/SEOArticleProcess';
import SEOArticleAI from './components/SEOArticleAI';
import SEOArticleResult from './components/SEOArticleResult';
import SEOArticleLeadForm from './components/SEOArticleLeadForm';
import Footer from '../landing-page/components/Footer';
import { useSEO } from '../../utils/seo';

export default function SEOArticlePage() {
  useSEO({
    title: 'SEO-статьи для бизнеса Москва | Контент-маркетинг и рост органического трафика',
    description: 'Профессиональные SEO-статьи для вывода сайта в ТОП Google и Яндекса. Контент-маркетинг, AI-SEO подход. Бесплатные заявки из поиска годами. От 3000 руб./мес.',
    keywords: 'SEO-статьи, контент-маркетинг, SEO-тексты, органический трафик, продвижение сайта контентом',
    canonical: '/SEO-article',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEOArticleHero />
      <SEOArticleSpecialization />
      <SEOArticleWhatIs />
      <SEOArticleStrategy />
      <SEOArticleProcess />
      <SEOArticleAI />
      <SEOArticleResult />
      <SEOArticleLeadForm />
      <Footer />
    </div>
  );
}
